import { writable } from "svelte/store";
import $axios from "../../../core/rest/axios";
export default class StatisticsService {
    constructor(dataProvider) {
        this._dataProvider = dataProvider;
        this._errorStatistics = writable(false);
        this._processingStatistics = writable(false);
        this._statistics = writable(null);
        this.loadStatistics();
    }
    loadStatistics() {
        this._processingStatistics.set(true);
        $axios.get("/search/ankety/statistiky")
            .then((response) => {
            this._statistics.set(response.data);
            this._errorStatistics.set(false);
        })
            .catch(() => this._errorStatistics.set(true))
            .finally(() => this._processingStatistics.set(false));
    }
    // SETTERS
    // GETTERS
    get statisticsSubs() {
        return this._statistics;
    }
    get processingStatisticsSubs() {
        return this._processingStatistics;
    }
    get errorStatisticsSubs() {
        return this._errorStatistics;
    }
}
